import { api, apiUrl } from "./../../api/index";

const url = `${apiUrl}/logs`;

export const fetchLogs = () => {
  return api(`${url}`, {
    method: "GET",
  });
};